import CopyToClipboardIcon from "features/copyClipBoard/copyClipBoard";
import React from "react";

export default function QuerySubmitSuccessBody({ classes, fileName, queryId }) {
  return (
    <div className={classes["query-submit-wrapper"]}>
      <span className={classes["text"]}>
        Great! We’ve received your query and started processing it.
      </span>

      <div className={classes["description"]}>
        We’ll notify you when your results are ready to download. You can access completed
        queries anytime under ‘My Queries’
      </div>

      <div className={classes["query-detail-content"]}>
        <span className={classes["label"]}>Query Name: </span>
        <span className={classes["value"]}>
          {fileName}
          <span>
            <CopyToClipboardIcon textToCopy={fileName} />
          </span>
        </span>
      </div>

      <div className={classes["query-detail-content"]}>
        <span className={classes["label"]}>Query ID:</span>
        <span className={classes["value"]}>
          {queryId}
          <span>
            <CopyToClipboardIcon textToCopy={queryId} />
          </span>
        </span>
      </div>
    </div>
  );
}
``